import filter from 'lodash/filter'
import forEach from 'lodash/forEach'

export const enableService = (name: string): void => {
  if ((window as any).UC_UI) {
    const { UC_UI } = (window as any)
    const services = filter(
      <Array<Record<string, any>>>UC_UI.getServicesBaseInfo(),
      service => service.name === name,
    )
    forEach(services, service => UC_UI.acceptService(service.id))
  }
}
